// extracted by mini-css-extract-plugin
export default {"container":"OrganizationsSearchableListRow__container-Ej3JM","item":"OrganizationsSearchableListRow__item-FeAJo"};